export class Coating {

  static readonly SECONDARY_CODES = ['BV'];

  hashValue: string;

  constructor (public codes: string[], public description: string, public labServiceId?: string, public coatingGroup?: string) {
    this.hashValue = this.hashCoatingListObject();
  }

  public hashCoatingListObject(): string {

    let returnValue: string;

    let hashDescription = this.description;
    if (hashDescription && hashDescription.length > 30) {
      hashDescription = hashDescription.substr(0, 30);
    }

    returnValue = this.getPreferredCode() + '|' + hashDescription;

    return returnValue;
  }

  public getPreferredCode(): string {

    let returnCode: string = null;
    if (this.codes) {
      this.codes.forEach(labServiceCode => {
        if (!Coating.SECONDARY_CODES.includes(labServiceCode)) {
          returnCode = labServiceCode;
        }
      });
    }
    return returnCode;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/data/coating.ts